import store from '../../../vuex/store';
const util = {
  expenseGroupFinBillNames(expense_group) {
    const kinds = expense_group.fin_bill_kinds.toString();
    if (!kinds) return '';
    const kinds_list = kinds.split(',');
    if (kinds_list.length === 0) return '';
    const hash = store.getters['async/fin_bill_kinds_hash'];
    const names = [];
    kinds_list.forEach((kind) => {
      const kind_obj = hash[kind];
      names.push(kind_obj ? kind_obj.label : `未定义财务单据类型(${kind})`);
    });
    return names.join(',');
  }
}
export default util;
